<template>
  <!-- principal -->

  <div class="wrapper-contenido">
    <div v-if="this.principal" class="portada">
      <div class="book-cover-inner">
        <div class="dato">
          <div id="contenedorSesion" v-show="datos">
            <button class="sesion" id="show-modal" @click="showModal = true">Iniciar Sesión</button>

            <modal v-if="showModal" @close="showModal = false" />
          </div>
          <form @submit.prevent="addTea">
            <div v-show="datos">
              <div class="ini">
                <a v-if="btnempezar" @click="empezar(), funcion()" class="iniciar">Empezar</a>
              </div>
            </div>
            <div>
              <!-- <audio class="audiopregunta" :src="this.audiopregunta"></audio> -->
              <h3 v-show="this.elije" class="elije">
                <img @click="enviarEvento(525)" src="../assets/audiob.gif" alt class="pbtn" /> ¿Quien es tu personaje
                Favorito?
              </h3>
            </div>

            <div v-show="this.preguntas" id="example-3">
              <label class="checkeable">
                <input type="radio" id="Loly" value="Loly" v-model="newTea.personajes" />
                <img src="../assets/seleccion/loly2.jpg" alt="Loly" />
                Loly
              </label>

              <label class="checkeable">
                <input type="radio" id="Loly 1.0" value="Loly 1.0" v-model="newTea.personajes" />
                <img src="../assets/seleccion/loly1.0.jpg" alt="Loly 1.0" />
                Robot Loly
              </label>

              <!--label class="checkeable">
                <input type="radio" id="Amiga de loly" value="Amiga de Loly" v-model="newTea.personajes" />
                <img src="../assets/seleccion/amigaloly.jpg" alt />
                Amiga de Loly
              </label>

              <label class="checkeable">
                <input type="radio" id="Amigo de Loly " value="Amigo de Loly " v-model="newTea.personajes" />
                <img src="../assets/seleccion/amigololy.jpg" alt />
                Amigo de Loly
              </label-->

              <label class="checkeable">
                <input type="radio" id="Loly cientifica" value="Loly cientifica" v-model="newTea.personajes" />
                <img src="../assets/seleccion/CIENTIFICA.jpg" alt /> Loly Cientifica
              </label>

              <!--label class="checkeable">
                <input type="radio" id="Profesor" value="Profesor" v-model="newTea.personajes" />
                <img src="../assets/seleccion/profe.jpg" alt /> Profesor
              </label-->

              <br />
            </div>

            <div v-if="this.elejido">
              <h6>
                Seleccionaste a:
                <span>{{ newTea.personajes }}</span>
              </h6>
            </div>
            <button v-if="this.botonconfirmar" type="submit" @click="confirmar(), win" class="env">Confirmar</button>

            <div v-if="this.botonesdescarga" class="descargas">
              <span @click="download" class="des">Descargar cuento</span>
              <span @click="downloadpictos" class="desp">Descargar Pictogramas</span>
            </div>
          </form>
        </div>
      </div>

    </div>

    <div class="wrapper-picto">
      <div v-bind:class="centerC">
      <div class="tooltip" v-for="(p7, i) in p" v-bind:key="i" :class="classpictogramas">
        <!-- etiquetas de nombre de los pictogramas -->
        <span class="tooltip-content">{{ formatString(p7.name) }}</span>
        
        <!-- imagenes de los pictogramas -->
        <img v-bind:class="marginF" class="picto" :src="p7.url" />
      </div>
      </div>
      <div v-if="this.imagenfinal">
      <img class="lolyfin" v-if="this.imagenfinal" src="../assets/FINAL.png" alt />
      </div>
    </div>

    <div class="wrapper-text">
      <!-- texto del cuento en parrafo -->
      <span v-for="(s, i) in textoarray" v-bind:key="i" :class="classtext">
        {{
            s
        }}
      </span>
    </div>


    <div v-if="botones" class="buttons">
      <div v-if="this.home">
        <a href="/">
          <img class="bfu" src="../assets/homeb.png" alt />
        </a>
      </div>
      <div v-if="this.sonido">
        <img @click="Animar()" class="bfu" src="../assets/audiob.gif" alt disable />
        <!-- <img @click.stop="Animar" class="bfu" src="../assets/audiob.gif" alt  style="background-color:yellow;"/> -->
      </div>
      <div>
        <a v-if="this.creditos" href="#/about">
          <img class="bfu" src="../assets/creditos.png" alt />
        </a>
      </div>
      <div>
        <a v-if="this.cerrar" href="http://midi.espol.edu.ec">
          <img class="bfu" src="../assets/cerrar.png" alt />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import modal from "./Modals/Modal.vue"
import axios from "axios";
// import Firebase, { app, functions } from "firebase";
// import config from "../config";
import Modal from "./Modals/Modal.vue";

// let cone = Firebase.initializeApp(config); //conexion con firebase viene del archivo config sdk unico
// let db = cone.database(); // para guardar la conexion
// let ninosRef = db.ref("tea");
let ninosRef = [];

var audiopregunta = new Audio(require("../assets/sonido/pregunta.mp3"));
var audiowin = new Audio(require("../assets/sonido/felicitaciones.mp3"));

export default {
  name: "Contenido",
  firebase: {
    tea: ninosRef,
  },
  props: {
    texto: {
      type: String,
    },
    pictogramas: {
      type: Array,
    },
    audio: {
      type: HTMLAudioElement,
    },
    funcion: {
      type: Function,
    },
    principal: {
      type: Boolean,
    },
    home: {
      type: Boolean,
    },
    sonido: {
      type: Boolean,
    },
    preguntas: {
      type: Boolean,
    },
    datos: {
      type: Boolean,
    },
    elije: {
      type: Boolean,
    },
    imagenfinal: {
      type: Boolean,
    },
    cerrar: {
      type: Boolean,
    },
    creditos: {
      type: Boolean,
    },
    botonesdescarga: {
      type: Boolean,
    },
    botonconfirmar: {
      type: Boolean,
    },
    elejido: {
      type: Boolean,
    },
    detenerAnimacion: {
      type: Boolean,
    },
  },

  data() {
    return {
      showModal: false,
      newTea: {
        nombre: "",
        edad: "",
        personajes: [],
      },
      textoarray: "",
      classtext: "visible",
      classpictogramas: "visible",
      botones: true,
      animando: false,
      name: true,
      edad: true,
      btnempezar: true,
      p: [],
      pbackup: [],
      setIntervalCurrent: null,
    };
  },

  mounted() {
    this.textoarray = this.texto.split(" ");
    this.p = this.pictogramas;
    this.pbackup = this.pictogramas;
    this.portada = this.portada;
  },
  watch: {
    detenerAnimacion: function (val) {
      if (val) {
        clearInterval(this.setIntervalCurrent);
        this.p = this.pbackup;
        this.classpictogramas = "visible";
        this.animando = false;
      }
    },
  },

  methods: {
    
    formatString(input) {
      if (input.length > 6) {
        return input;
      }
      return `\xa0\xa0 ${input} \xa0\xa0`;
    },
    confirmar() {
      this.enviarEvento(526);
      if (localStorage.getItem("grabar") == 'true') {
        this.enviarEvento(71);
        localStorage.setItem("grabar", 'false');
      } else {
        localStorage.setItem("comprobar", "No hay Información");
      }
    },

    casa() {
      this.enviarEvento(28);
      if (localStorage.getItem("grabar") == 'true') {
        this.enviarEvento(71);
        localStorage.setItem("grabar", 'false');
      } else {
        localStorage.setItem("comprobar", "No hay Información");
      }

    },

    empezar() {
      if (localStorage.getItem("grabar") == 'true') {
        this.enviarEvento(70);
      }
    },


    async enviarEvento(Id) {
      //var fecha = new Date().toLocaleDateString();
      //console.log(fecha);
     
      //var fechaHora = fecha + " " + new Date().toLocaleTimeString();
      //var robotS = localStorage.getItem("escuela") + "-" + localStorage.getItem("salam") + "-" + "Conociendo a Loly" + "_" + fechaHora;
      // var robotS = localStorage.getItem("escuela") + "-" + localStorage.getItem("salam") + "-" + "Conociendo a Loly";
      
      // const config = {
      //   headers: { 'Authorization': localStorage.getItem("token") }
      // };
      // const bodyE = {
      //   urlRobot: 'http://localhost:8910',
      //   estudiante: localStorage.getItem("nombreP"),
      //   robot: robotS
      // };
      // await axios.post(localStorage.getItem("urlm") + '/lolyapi/v1/send/' + Id, bodyE, config)
      //   .then(response => {
      //     localStorage.setItem("comprobar", response.status);
      //   });
    },

    clicked(value) {
      this.modal = value;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async Animar() {
      if (!this.animando) {
        this.classpictogramas = "hide";
        let temp = this.p;
        this.audio.currentTime = 0;
        this.audio.play();

        if (this.classpictogramas === "hide") {
          this.animando = true;
          this.classpictogramas = "visible";
          this.p = [];

          if (temp && temp.length > 0) {
            for (let cont = 0; cont < temp.length; cont++) {
              let pictogramaActual = temp[cont];
              await this.sleep(453 + (pictogramaActual.delay??0));
              this.p.push(pictogramaActual);
            }
          }

          this.animando = false;
        }
      }
    },
    pregunta() {
      audiopregunta.play();
    },

    win() {
      audiowin.play();
      //window.location.reload();
      setTimeout("document.location.reload()", 10000);
    },

    download() {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/cuento.pdf`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        var filelink = document.createElement("a");
        filelink.href = fileUrl;
        filelink.setAttribute("download", "cuento.pdf");
        document.body.appendChild(filelink);
        filelink.click();
      });
    },

    downloadpictos() {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/pictos.pdf`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        var filelink = document.createElement("a");
        filelink.href = fileUrl;
        filelink.setAttribute("download", "pictos.pdf");
        document.body.appendChild(filelink);
        filelink.click();
      });
    },

    addTea() {
      // var x = document.getElementById("nombre").value;
      // var y = document.getElementById("edad").value;
      var x = localStorage.getItem("nombreP");
      var y = localStorage.getItem("edadP");
      this.newTea.nombre = x;
      this.newTea.edad = y;
      console.log(x);
      console.log(y);
      if (this.newTea.nombre == "" && this.newTea.edad == "") {
        this.newTea.nombre = "general";
        this.newTea.edad = "n/a";
        ninosRef.push(this.newTea);
        this.newTea.nombre = "";
        this.newTea.edad = "";
        this.botonconfirmar = false;
        this.win();
      }
      else {
        ninosRef.push(this.newTea);
        this.newTea.nombre = "";
        this.newTea.edad = "";
        this.botonconfirmar = false;
        this.win();
      }
    },
  },
  computed: {    centerC: function() {
        return this.imagenfinal ? 'center-cont' : '';
    },
    centerC: function() {
        return this.imagenfinal ? 'center-cont' : '';
    },
    /*
    marginF: function() {
        return this.imagenfinal ? 'marginFinal' : '';
    },*/
  },
  components: { Modal }
};
</script>

<style scoped>
.list-item,
span {
  /* display: ruby; */
  display: inline-block;
  margin-right: 10px;
  transition: 0.2s ease;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(30px);
}

#example-3 {
  display: flex;
  font-size: 15pt;
}

.checkeable input {
  display: none;
}

.checkeable img {
  width: 100px;
  border: 5px solid transparent;
}

.checkeable input {
  display: none;
}

.checkeable input:checked+img {
  border-color: Green;
}

.elije {
  padding-top: 70px;
}

.descargas {
  font-size: 14pt;
}

.tooltip {
  width: 20%;
  padding: 12px;
  margin: auto;
  text-align: center;
  /*cursor: pointer;*/
  float: left;
  position: relative;
  display: inline-block;
  margin-top:2rem;
}

.tooltip-content {
  /* opacity: 0; */
  /* background-color: rgb(12, 128, 47); */
  color: rgb(0, 0, 0);
  text-align: center;
  border-radius: 6px;
  /*padding: 5px 10px;*/
  /*margin: auto;*/
  /*margin-left: -20px;
  margin-right: -20px;*/
  z-index: 1;
  display: inline-block;   
  text-align: center; 
  padding-bottom: 10px;
  position: absolute;
  top: 0;

  left:0;
  margin-right: 0px !important;
  width: 120%;
  margin-left: -10%;
}
/*
.tooltip:hover .tooltip-content {
  color: rgb(255, 255, 255);
  background-color: rgb(12, 128, 47);
  text-align: center;
  border-radius: 6px;
  padding: 5px 20px;
  margin: auto;
  z-index: 1;
}*/

.hide {
  visibility: hidden;
  transition: 0.1s;
}

.visible {
  visibility: visible;
  transition: 0.1s;
}

.wrapper-contenido {
  /* height: fit-content; */
  height: 100%;
  position: relative;
  box-sizing: border-box;
  border-left: 1px solid #ccc;
  /* background-image: url("../assets/fondotenue.png"); */
  background-image: url("../assets/fondoc.png");

  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.edad,
.name {
  display: inline-block;
  box-sizing: border-box;
  color: #8d743b;
  background-color: #f4e695;
  padding: 4px;
  border: 5px solid #2ec183;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 700;
  margin-top: 3px;
  margin-left: 4px;
  font-size: 21pt;
  margin-bottom: 10px;
}

.preguntas {
  margin: 0 auto;
}

.sel-charact {
  display: flex;
  border-radius: 5px;
  justify-content: center;
}

.personaje {
  box-sizing: border-box;
  margin: 5px;
  width: 200px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-size: 8pt;
}

.imapersonaje {
  width: 100px;
}

.env {
  box-sizing: border-box;
  color: #8d743b;
  background-color: #f4e695;
  padding: 10px;
  border: 10px solid #2ec183;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 700;
  margin-top: 0px;
  font-size: 20px;
}

.sesion {
  box-sizing: border-box;
  color: #8d743b;
  background-color: #f4e695;
  padding: 20px;
  border: 10px solid #2ec183;
  border-radius: 25px;
  cursor: pointer;
  font-size: 40px;
  font-weight: 700;
  margin-top: 10px;
  text-overflow: ellipsis;
  white-space: pre;
}

#contenedorSesion {
  margin-top: 40px;
}

.iniciar {
  box-sizing: border-box;
  color: #8d743b;
  background-color: #f4e695;
  padding: 20px;
  border: 10px solid #2ec183;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 700;
  margin-top: 10px;
}

.ini {
  margin-top: 40px;
}

.wrapper-text {
  /* clear: both;
  padding-top: 40px;
  font-size: 28px;
} */

  clear: both;
  padding-top: 40px;
  font-size: 18pt;
  box-sizing: border-box;
  text-align: center;
}

.buttons {
  position: absolute;
  display: block;
  margin: 0;
  width: 100%;
  bottom: 1%;
  box-sizing: border-box;
}

.buttons div {
  width: 70%;
  float: left;
  display: contents;
  text-align: center;
}

.wrapper-picto {
  width: 100%;
  /* height: fit-content; */
  height: 50%;
  margin: auto;
  /*display: flex;
  justify-content: center;*/
  border: 0vmin;
}

.center-cont{
  display:flex;
  justify-content:center;
}

/* .picto {
  width: 90px;
  margin: auto 5px 0 5px;
  box-sizing: border-box;
  box-shadow: 0 0 10px #c7cdda;
} */

.picto {
  width: auto;
  margin: auto;
  box-sizing: border-box;
  box-shadow: 0 0 10px #c7cdda;
  display: block;
  width: 100%;
  margin-top:0.8rem;
}
/*
.marginFinal{
  margin-top:4.5rem !important;
}*/

.opcionescaja {
  display: block;
}

.portada {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 30px;
  font-size: 24pt;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pbtn {
  width: 30px;
  height: 30px;
  padding: 0;
  margin-top: 0;
  margin-right: 3px;
}

.des,
.desp,
.selecpersonaje {
  box-sizing: border-box;
  color: #8d743b;
  background-color: #f4e695;
  padding: 10px;
  border: 10px solid #2ec183;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 700;
  margin-top: 15px;
}

.dato {
  display: table-caption;
  margin-bottom: auto;
}

.book-cover-inner {
  padding-bottom: 270px;
}

.book-cover-title {
  margin: 0;
  padding-bottom: 80px;
}

.book-cover-buttons {
  margin: 0 auto;
  width: 100%;
}

.bfu {
  padding-top: 20px;
  width: 14%;
  margin: 14px;
  padding-left: 5px;
  padding-right: 15px;
}

@media only screen and (orientation: portrait) {
  .wrapper {
    display: none;
  }
}

@media only screen and (max-width: 1600px) {
  .body-cuento {
    height: 800px;
  }

  .checkeable img {
    width: 87px;
  }
}

@media only screen and (max-width: 1440px) {
  .body-cuento {
    height: 740px;
  }

  .elije {
    padding-top: 0px;
  }
}

@media only screen and (max-width: 1280px) {
  .body-cuento {
    height: 700px;
  }
}

@media only screen and (max-width: 1200px) {
  .wrapper-text {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14pt;
    padding-top: 0px;
  }

  .tooltip-content {
    font-size: 10pt;
  }

  .portada {
    font-size: 13pt;
  }
  .marginFinal{
    margin-top:2rem !important;
  }
}

@media only screen and (max-width: 1024px) {
  .body-cuento {
    height: 600px;
  }

  .picto {
    width: 100%;
    margin-top:0.3rem;
  }
  .marginFinal{
    margin-top:2rem !important;
  }

  .env {
    font-size: 15pt;
  }

  .tooltip {
    padding: 10px;
  }

  .descargas {
    display: block;
    font-size: 10pt;
  }

  .dato {
    padding-top: 100px;
  }

  .elije {
    padding-top: 0px;
  }

  #example-3 {
    font-size: 10pt;
  }

  .checkeable img {
    width: 60px;
  }

  .bfu {
    padding-top: 20px;
    width: 13%;
    margin: 7px;
    padding-left: 3px;
    padding-right: 16px;
  }
}

@media only screen and (max-width: 825px) {
  .body-cuento {
    height: 375px;
  }

  .contenido {
    padding: 10px;
  }

  .tooltip {
    padding: 8px;
  }

  .picto {
    width: 100%;
    margin-top:0.3rem;

  }

  .imapersonaje {
    width: 43px;
  }

  .des,
  .desp {
    padding: 5px;
    border: 5px solid #2ec183;
  }

  .dato {
    padding-top: 160px;
  }

  .edad,
  .name {
    font-size: 14pt;
  }

  .env {
    margin-top: 0px;
    font-size: 20px;
  }

  .lolyfin {
    width: 70%;
  }

  .elije {
    padding-top: 30px;
    font-size: 10pt;
  }

  .descargas {
    font-size: 8pt;
  }

  .bfu {
    padding-top: 20px;
    width: 16%;
    margin: 0px;
    padding-left: 5px;
    padding-right: 15px;
  }

  .env {
    padding: 5px;
    border: 7px solid #2ec183;
    border-radius: 12px;
    margin-top: 31px;
    font-size: 9px;
  }

  .checkeable img {
    width: 37px;
    border: 5px solid transparent;
  }

  #example-3 {
    font-size: 7pt;
  }
}

@media only screen and (max-width: 812px) {
  .wrapper-text {
    font-size: 7pt;
  }

  .tooltip-content {
    text-align: center;
    font-size: 12px;
  }

  .picto {
    width: 135%;
    margin-top:0.2rem;
  }

  .tooltip {
    padding: 15px;
    margin-top:10px;
  }

  .marginFinal{
    margin-top:2rem !important;
  }
  .des,
  .desp,
  .selecpersonaje {
    display: inline-block;
    box-sizing: border-box;
    color: #8d743b;
    background-color: #f4e695;
    padding: 4px;
    border: 5px solid #2ec183;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 700;
    margin-top: 3px;
    font-size: 8pt;
  }

  .book-cover-buttons {
    width: 35%;
  }

  .empezar {
    padding: 1px;
  }
}

@media only screen and (max-width: 768px) {
  .wrapper-text[data-v-4aed0a6c] {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 10pt;
  }

  .tooltip {
    width: 15%;
    padding: 6px;
    margin: auto;
    text-align: center;
    cursor: pointer;
    float: left;
  }

  .tooltip-content {
    padding: 5px 0px;
    font-size: 7pt;
  }

  .picto {
    width: 114%;
    margin-top:0.9rem;
  }
  .marginFinal{
    margin-top:3.5rem !important;
  }

  .portada {
    font-size: 13pt;
  }

  .book-cover-buttons {
    width: 57%;
  }

  .des,
  .desp,
  .selecpersonaje {
    display: inline-block;
    box-sizing: border-box;
    color: #8d743b;
    background-color: #f4e695;
    padding: 4px;
    border: 5px solid #2ec183;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 700;
    margin-top: 3px;
    font-size: 8pt;
  }
}

@media only screen and (max-width: 640px) {
  .portada {
    font-size: 11pt;
  }

  .wrapper-text {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 10pt;
  }

  .tooltip-content {
    font-size: 6pt;
    padding: 6px;
    margin: auto;
  }

  .tooltip {
    width: 15%;
    padding: 6px;
    margin: auto;
    text-align: center;
    cursor: pointer;
    float: left;
  }

  .picto {
    width: 100%;
    margin-top:0.6em;
  }
  .marginFinal{
    margin-top:3.5rem !important;
  }

  .arrow {
    width: 36px;
  }

  .fisq {
    left: 3px;
  }

  .fdere {
    right: 3px;
  }
}

@media only screen and (max-width: 568px) {
  .body-cuento {
    height: 320px;
  }

  .dato {
    padding-top: 176px;
  }

  .checkeable img {
    width: 30px;
  }

  #example-3 {
    font-size: 6pt;
  }

  .env {
    padding: 5px;
    border: 7px solid #2ec183;
    border-radius: 12px;
    margin-top: 0px;
    font-size: 9px;
  }

  .des,
  .desp,
  .selecpersonaje {
    display: inline-block;
    box-sizing: border-box;
    color: #8d743b;
    background-color: #f4e695;
    padding: 4px;
    border: 6px solid #2ec183;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 700;
    margin-top: 3px;
    font-size: 6pt;
  }
}

@media only screen and (max-width: 415px) {
  .alert {
    display: block;
  }
}

@media only screen and (max-width: 375) {
  .tooltip-content {
    font-size: 7px;
    padding: 0px 0px;
  }

  .wrapper-text {
    font-size: 9px;
  }

  .book-cover-buttons {
    width: 25%;
  }
}
</style>
